<template>
	<v-app-bar fixed app height="65" style="width: auto;">
        <!-- >>> Drawer -->
        <v-btn
            style="margin-left: 5px !important"
            depressed
            elevation="1"
            min-width="0"
            @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>
        <!-- <<< Drawer -->


		<v-toolbar-title class="hidden-sm-and-down">
        SunFlight - Airports
        </v-toolbar-title>


		<!-- >>> Filter TextField -->
		<v-text-field v-model="filterTerm"
			style="margin-left: 60px; margin-top:22px;"
			label=" Filter Airports"
			@keyup="onKeyup_filterAirports" />
		<!-- <<< Filter TextField -->


		<span style="margin-left: 30px; margin-top: 31px;"><strong>Shown Airports: </strong></span>


		<v-spacer />


        <!-- >>> Comes later ... -->
		<v-btn raised elevation="1" min-width="0" text style="margin-left: 40px; margin-right: 0px;">
			<v-icon color="primary">
				mdi-overscan
			</v-icon>
		</v-btn>
        <!-- <<< Comes later ... -->
	</v-app-bar>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';


	export default {
		name: 'FlightsAppBar',

        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            }

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------
                filterTerm: ''
            };

        }, // eo funtion data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Airports_Filtered'
            ])

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

			...mapActions([
				'actn_set_filterAirports_filterTerm' // save
			]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
            * onKeyup_filterAirports()
            *
            * Desc:
            * Note:
            *
            */
			onKeyup_filterAirports: function() {

				const me = this;


				me.$toc('>>> views/flights/airports/components/core/AppBar.vue >>> onKeyup_filterAirports');
				this.actn_set_filterAirports_filterTerm(this.filterTerm);

			} // eo function onKeyup_filterAirports()

        } // eo methods
        /* <<< ****************************************************************/
	};
</script>

<style scoped>
	.theme--light.v-app-bar.v-toolbar.v-sheet {
		background-color: #FFFFFF;
		border-color: #FFFFFF;
		color: rgba(0, 0, 0, 0.87);
	}

	.v-toolbar__title {
		font-weight: 300;
		color: #555555;
		font-size: 18px;
		margin-bottom: 0px;
	}

	.theme--light.v-btn.v-btn--has-bg {
		background-color: #fff;
	}

    .v-label {
        font-size: 14px !important; /* 16px */
    }

    .sdr-custom-text-input input {
        text-transform: uppercase;
    }

</style>

<style>
    .sdr-custom-button-with-icon .v-icon::before {
        color: #AB3B7A;
    }

    .sdr-custom-button-with-icon.v-btn--disabled .v-icon::before {
        color: #e0e0e0;
    }

    .v-slider__tick, .v-slider__tick.v-slider__tick--filled {
        width: 7px !important;
        height: 7px !important;
        border-radius: 50%;
        margin-top: -3px;
        margin-left: -3px;
        background: #AB3B7A;
        cursor: pointer;
    }

    .v-slider__tick:first-of-type .v-slider__tick-label {
        transform: translateX(-50%) !important;
    }

    .v-slider__tick:last-of-type .v-slider__tick-label {
        transform: translateX(-25%) !important;
    }

    .theme--light.v-label {
		color: rgba(0, 0, 0, 0.7);
	}
</style>
